import { SubscriptionStatus } from 'redux/reducers/authReducer';
import { useCurrentSubscription } from './useCurrentOrganization';

export function useFreePlan() {
  const currentSubscription = useCurrentSubscription();

  return currentSubscription.status === SubscriptionStatus.Free;
}
